import { NotificationModalComponent } from "widgets-module/components/notification/notification-modal.component";
import { NotificationOptionsModel } from "widgets-module/components/notification/notification-options.model";
import { NotificationPaneComponent } from "widgets-module/components/notification/notification-pane.component";

export class NotificationService {
    private _currentContext: JQuery = null;
    private _options: NotificationOptionsModel = null;

    private _panes: Array<NotificationPaneComponent> = [];
    private _modal: NotificationModalComponent = null;

    private bindEvents(): void {
        this._panes.forEach((pane) => {
            pane.on(NotificationPaneComponent.REMOVE_EVENT)
                .subscribe((x: NotificationPaneComponent) => {
                    this.markAsClosed(x.id);
                    x.destroy();
                });
        });

        if (this._modal) {
            this._modal.on(NotificationModalComponent.REMOVE_EVENT).subscribe((x: NotificationModalComponent) => {
                this.markAsClosed(x.id);
                x.destroy();
            });
        }
    }

    private get closedNotificationIds(): Array<string> {
        const closedIdsValue = sessionStorage.getItem(this._options.sessionKey) || "[]";
        return JSON.parse(closedIdsValue) as Array<string> || new Array<string>();
    }

    private markAsClosed(id: string): void {
        const closedIds = this.closedNotificationIds;
        closedIds.push(id);
        sessionStorage.setItem(this._options.sessionKey, JSON.stringify(closedIds));
    }

    private parseContext(): void {
        const panes = $(NotificationPaneComponent.SELECTOR, this._currentContext);
        panes.each((index, entry) => {
            const paneContext = $(entry);
            const pane = new NotificationPaneComponent();
            pane.init(paneContext);
            this._panes.push(pane);
        });

        const modalContext = $(NotificationModalComponent.SELECTOR, this._currentContext);
        if (modalContext && modalContext.length) {
            this._modal = new NotificationModalComponent();
            this._modal.init(modalContext.first(), this._options.displayDelayInMilliseconds);
        }
    }

    private showNotifications(): void {
        const closedIds = this.closedNotificationIds;

        this._panes.forEach((x) => {
            if (!closedIds.includes(x.id)) {
                x.show();
            }
        });

        if (this._modal && !!this._modal.id && !closedIds.includes(this._modal.id)) {
            this._modal.show();
        }
    }

    public init(context: JQuery, options: NotificationOptionsModel): void {
        this._currentContext = context || this._currentContext;
        this._options = options || this._options;

        this.parseContext();
        this.showNotifications();
        this.bindEvents();
    }
}
